import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ISample } from '../../samples/interface/sample.interface';
import { ITaxon } from '../../taxon/taxon.interface';
import { IMeasurement } from '../measurement.interface';
import { MeasurementActionMenuComponent } from './measurement-action-menu.component';
import { CommonModule } from '@angular/common';
import { MeasurementAnalysedCountComponent } from './measurement-analysed-count.component';
import { TaxonAbundanceCategoryService } from '../../taxon-abundance-category/services/taxon-abundance-category.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  standalone: true,
  imports: [
    MeasurementAnalysedCountComponent,
    MeasurementActionMenuComponent,
    MatBadgeModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    CommonModule,
  ],
  selector: 'app-measurement-list-item',
  template: `
    <div style="padding: 0 4px">
      <div style="display: flex; align-items: center; gap: 16px">
        <div style="flex: 1">
          <span>{{ taxon.taxonName }}</span>
          @if (bracketText) {
            <span style="color: #88f"> ({{ bracketText }})</span>
          }
          <span style="opacity: 50%"> (ID: {{ taxon.cprTaxonId }})</span>
        </div>
        @if (category) {
          <span style="opacity: 50%">(C{{ category }})</span>
        } @else if (hasMissingCategoryWarning) {
          <mat-icon
            aria-label="Missing factor applied category"
            class="warning-icon"
            fontIcon="warning_amber"
            matTooltip="Factor applied category is missing from this measurement"
          />
        }

        <span style="min-width: 40px; text-align: right">
          <app-measurement-analysed-count
            [analysedCount]="measurement.analysedCount"
          ></app-measurement-analysed-count>
        </span>

        <app-measurement-action-menu
          [measurement]="measurement"
          (delete)="delete.emit()"
          (update)="measurement = $event; this.update.emit($event)"
        />
      </div>
      @if (measurement.comment) {
        <i style="opacity: 50%; padding-left: 16px">{{ measurement.comment }}</i>
      }
    </div>
  `,
  styles: [
    `
      :host {
        font-size: calc(var(--scale, 1) * 16px);
      }
    `,
  ],
})
export class MeasurementListItemComponent implements OnChanges {
  @Input() measurement: IMeasurement;
  @Input() sample: ISample;
  @Input() taxon: ITaxon;

  @Input() bracketText?: string;

  @Output() delete = new EventEmitter<void>();
  @Output() update = new EventEmitter<IMeasurement>();

  category?: number;

  get hasMissingCategoryWarning() {
    return !!this.measurement && !this.measurement.taxonAbundanceCategoryId;
  }

  constructor(private readonly taxonAbundanceCategoryService: TaxonAbundanceCategoryService) {}

  async ngOnChanges() {
    this.category = undefined;

    if (!this.measurement?.taxonAbundanceCategoryId) {
      return;
    }

    try {
      this.category = (
        await this.taxonAbundanceCategoryService.getCategoryById(
          this.measurement.taxonAbundanceCategoryId,
        )
      )?.taxonCategory;
    } catch {
      this.category = undefined;
    }
  }
}
